export default __webpack_public_path__ + "static/media/evo-grey.4c9b7ae5.svg";